__turbopack_context__.v({
  "answer": "FAQs-module__AuoOcG__answer",
  "heading": "FAQs-module__AuoOcG__heading",
  "item": "FAQs-module__AuoOcG__item",
  "list": "FAQs-module__AuoOcG__list",
  "section": "FAQs-module__AuoOcG__section",
});
